import React, { Component } from "react";
import Input from "../../2/Controls/Input";

class MessageTemplateStep extends Component {
  constructor(props) {
    super(props);
    this.handleSmsTemplateChange = this.handleSmsTemplateChange.bind(this);
    this.handleWhatsappTemplateChange = this.handleWhatsappTemplateChange.bind(this);
  }

  handleSmsTemplateChange = (value) => {
    const { formData, smsTemplates, offerList, couponList, updateFormData } = this.props;
    let smsTemplate = smsTemplates.find((s) => s.key === value).SMSTemplate || "";

    if (smsTemplate !== "" && formData.offerID !== "") {
      let offer = offerList.find((o) => o.key === formData.offerID) || null;

      if (offer) {
        smsTemplate = smsTemplate.replace("<offer>", offer.Name);
      } else {
        let coupon = couponList.find((o) => o.key === formData.offerID) || null;

        if (coupon) {
          smsTemplate = smsTemplate.replace("<coupon>", coupon.Name);
        }
      }
    }

    updateFormData("smsTemplateID", value);
    updateFormData("smsTemplate", smsTemplate);
  };

  handleWhatsappTemplateChange = (id) => {
    const { whatsappTemplates, updateFormData } = this.props;
    const template = whatsappTemplates.find((t) => t._id === id);
    updateFormData("selectedWhatsappTemplate", template);
  };

  styles = {
    container: {
      marginBottom: "24px",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "bold",
      marginBottom: "24px",
    },
    channelToggles: {
      display: "flex",
      gap: "24px",
      marginBottom: "4px",
    },
    channelLabel: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    checkbox: {
      margin: "0",
    },
    errorText: {
      fontSize: "14px",
      color: "#f44336",
      marginTop: "4px",
    },
    gridContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "24px",
    },
    card: {
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      padding: "16px",
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    },
    cardTitle: {
      fontWeight: "600",
      marginBottom: "16px",
    },
    mediaContainer: {
      marginBottom: "16px",
    },
    image: {
      borderRadius: "8px",
      maxWidth: "100%",
      height: "auto",
      maxHeight: "192px",
    },
    video: {
      borderRadius: "8px",
      maxWidth: "100%",
      height: "auto",
      maxHeight: "192px",
    },
    audio: {
      width: "100%",
    },
    documentContainer: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      padding: "12px",
    },
    documentIcon: {
      backgroundColor: "#e3f2fd",
      color: "#1976d2",
      padding: "8px",
      borderRadius: "8px",
    },
    documentInfo: {
      flex: "1",
      minWidth: "0",
    },
    documentFilename: {
      fontSize: "14px",
      fontWeight: "500",
      color: "#616161",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      margin: "0 0 4px 0",
    },
    documentType: {
      fontSize: "12px",
      color: "#9e9e9e",
      margin: "0",
    },
    messagePreview: {
      backgroundColor: "#f5f5f5",
      padding: "12px",
      borderRadius: "8px",
    },
    messageText: {
      color: "#424242",
      margin: "0",
    },
  };

  // Helper function to safely check if property exists
  hasProperty = (obj, prop) => {
    return obj && Object.prototype.hasOwnProperty.call(obj, prop);
  };

  render() {
    const {
      formData,
      updateFormData,
      channelOptions,
      smsTemplates,
      whatsappTemplates,
      formatedWhatsappTemplates,
      offerList,
      couponList,
      errors,
    } = this.props;

    return (
      <div style={this.styles.container}>
        <h2 style={this.styles.heading}>Campaign Message</h2>

        {/* Channel Toggles */}
        <div style={this.styles.channelToggles}>
          <label style={this.styles.channelLabel}>
            <input
              type="checkbox"
              style={this.styles.checkbox}
              checked={formData.enableWhatsapp || false}
              onChange={(e) => updateFormData("enableWhatsapp", e.target.checked)}
            />
            Whatsapp
          </label>
          <label style={this.styles.channelLabel}>
            <input
              type="checkbox"
              style={this.styles.checkbox}
              checked={formData.enableSMS || false}
              onChange={(e) => updateFormData("enableSMS", e.target.checked)}
            />
            SMS
          </label>
        </div>

        {errors.campaignChannel && (
          <div style={this.styles.errorText}>{errors.campaignChannel}</div>
        )}

        <div style={this.styles.gridContainer}>
          {/* Whatsapp */}
          {formData.enableWhatsapp && (
            <div style={this.styles.card}>
              <h3 style={this.styles.cardTitle}>WhatsApp Message</h3>
              <Input
                type="select"
                label="Select Whatsapp Template"
                value={formData.selectedWhatsappTemplate && this.hasProperty(formData.selectedWhatsappTemplate, "_id") ? formData.selectedWhatsappTemplate._id : ""}
                onChange={(e) => this.handleWhatsappTemplateChange(e)}
                error={errors.whatsappTemplate}
                required
              >
                <option value="">Select a template</option>
                {formatedWhatsappTemplates.map((template) => (
                  <option key={template.value} value={template.value}>
                    {template.label}
                  </option>
                ))}
              </Input>

              {formData.selectedWhatsappTemplate && (
                <div style={{ marginTop: "16px" }}>
                  {formData.selectedWhatsappTemplate.media && this.hasProperty(formData.selectedWhatsappTemplate.media, "type") && (
                    <div style={this.styles.mediaContainer}>
                      {this.hasProperty(formData.selectedWhatsappTemplate.media, "type") && 
                        formData.selectedWhatsappTemplate.media.type === "image" && (
                        <img
                          src={formData.selectedWhatsappTemplate.media.url}
                          alt={this.hasProperty(formData.selectedWhatsappTemplate.media, "filename") ? formData.selectedWhatsappTemplate.media.filename : ""}
                          style={this.styles.image}
                        />
                      )}

                      {this.hasProperty(formData.selectedWhatsappTemplate.media, "type") && 
                        formData.selectedWhatsappTemplate.media.type === "video" && (
                        <video
                          controls
                          style={this.styles.video}
                          src={formData.selectedWhatsappTemplate.media.url}
                        />
                      )}

                      {this.hasProperty(formData.selectedWhatsappTemplate.media, "type") && 
                        formData.selectedWhatsappTemplate.media.type === "audio" && (
                        <audio controls style={this.styles.audio}>
                          <source
                            src={formData.selectedWhatsappTemplate.media.url}
                          />
                          Your browser does not support the audio element.
                        </audio>
                      )}

                      {this.hasProperty(formData.selectedWhatsappTemplate.media, "type") && 
                        ["document"].includes(formData.selectedWhatsappTemplate.media.type) && (
                        <div style={this.styles.documentContainer}>
                          <div style={this.styles.documentIcon}>📄</div>
                          <div style={this.styles.documentInfo}>
                            <p style={this.styles.documentFilename}>
                              {(this.hasProperty(formData.selectedWhatsappTemplate.media, "filename") && formData.selectedWhatsappTemplate.media.filename) ||
                                "Document"}
                            </p>
                            <p style={this.styles.documentType}>
                              {formData.selectedWhatsappTemplate.media.type.toUpperCase()}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  <div style={this.styles.messagePreview}>
                    <p style={this.styles.messageText}>
                      {formData.selectedWhatsappTemplate.content}
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* SMS */}
          {formData.enableSMS && (
            <div style={this.styles.card}>
              <h3 style={this.styles.cardTitle}>SMS Message</h3>
              <Input
                type="select"
                label="Select SMS Template"
                value={formData.smsTemplateID}
                onChange={(e) => this.handleSmsTemplateChange(e)}
                error={errors.smsTemplateID}
                required
              >
                <option value="">Select a template</option>
                {smsTemplates.map((data) => (
                  <option key={data.key} value={data.key}>
                    {data.Name}
                  </option>
                ))}
              </Input>
              
              {formData.smsTemplateID && (
                <div style={{ marginTop: "16px" }}>
                  <Input
                    type="textarea"
                    label="Message Preview"
                    value={formData.smsTemplate}
                    onChange={() => {}}
                  />
                </div>
              )}
            </div>
          )}

          {/* Email */}
          {formData.enableEmail && (
            <div style={this.styles.card}>
              <h3 style={this.styles.cardTitle}>Email Message</h3>
              <Input
                type="select"
                label="Select Email Template"
                value={formData.emailTemplate}
                onChange={(e) => updateFormData("emailTemplate", e)}
                error={errors.emailTemplateID}
                required
              >
                <option value="">Select a template</option>
              </Input>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default MessageTemplateStep;